import { inject, injectable } from "inversify";
import SERVICE_IDENTIFIER from "../constants/identifiers";
import SystemConfig, {
	buildParagraphUrl,
	CONFIG_PARAMS,
} from "../system/SystemConfig";
import events from "../events/EventsObservable";
import { EVENTS } from "../events/baseEvents";
import { ACTION_EVENTS } from "../ui/UserAction";
import BaseDOM from "../ui/BaseDOM";
import System from "../system/System";
import AbstractIframePage from "./AbstractIfarmePage";

@injectable()
export default class IframeInfopages extends AbstractIframePage {
	protected appName: string = "pages";

	constructor(
		@inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
		@inject(SERVICE_IDENTIFIER.DOM) DOM: BaseDOM,
		@inject(SERVICE_IDENTIFIER.System) system: System
		// @inject(SERVICE_IDENTIFIER.UIStates) protected states: AbstractStates
	) {
		super(config, DOM, system);
		events.subscribe(EVENTS.INFO_CLOSE_REQUEST, () => this.close());
		events.subscribe(ACTION_EVENTS.ACTION_INFO_TOGGLE, () => this.toggle());
	}

	create(): void {
		if (this.created) return;
		super.create();
		this.iframe.setSrc(
			buildParagraphUrl(
				this.config.get(CONFIG_PARAMS.IS_PARAGRAPH),
				this.config,
				{ type: "info" }
			)
		);
		this.iframe.setCloseAction(ACTION_EVENTS.ACTION_INFO_TOGGLE);
	}

	open(): Promise<boolean> {
		// this.states.setState(STATES.INFOPAGE)
		return super.open();
	}

	close(): Promise<boolean> {
		// this.states.setState(STATES.IDLE)
		return super.close();
	}
}
